import { DialogProps } from 'components/dialog';
import { SelectOption } from 'components/select';
import { UploadFile, ExpensesType } from 'types';
import { PaymentsFormProps } from 'components/payments-form/types';

export enum ExpenseTypeCashStatus {
  Prepaid = 'Prepaid',
  Regular = 'Regular',
}

export interface FormValues {
  date: string;
  notes: string;
  amount: string;
  eventId?: number;
  employeeId: string;
  type?: ExpensesType;
  categoryId?: string;
  receiptUrl?: string;
  receipt?: UploadFile;
  isCashFromEvent: boolean;
}

interface OnSuccessSubmit extends FormValues {
  id: number;
}

export interface CreateBonusAdvanceDialogProps
  extends
    Partial<Pick<DialogProps, 'trigger'>>,
    Pick<PaymentsFormProps<FormValues>, 'customEvents'> {
  eventId?: number;
  employeeId?: string;
  customTitle?: string;
  isAdvances?: boolean;
  withReceipt?: boolean;
  isWideDialog?: boolean;
  isDisableEvent?: boolean;
  isAmountLocked?: boolean;
  hideCashFromEvent?: boolean;
  isOnlyCashLocation?: boolean;
  showSelectExpensesType?: boolean;
  customTypeValues?: ExpensesType[];
  customEmployeeOptions?: SelectOption[];
  onSubmittingChange?: (pending: boolean) => void;
  onSuccessSubmit?: (values: OnSuccessSubmit) => void;
  initialValues?: { date?: Date; notes?: string; amount?: string };
}

export interface GetInitialValues {
  eventId?: number;
  employeeId?: string;
  isOnlyCashLocation?: boolean;
  initialValues?: CreateBonusAdvanceDialogProps['initialValues'];
}
